import React from "react";
import ModalContentBaseXl from '../redux/components/modal/modal_content_base_xl';
import ModalAlert from '../redux/components/modal/modal_alert';
import ModalLoader from '../redux/components/modal/modal_loader';
import "babel-polyfill";

export const GenerateOutlineModal = ({onAcceptEventTitle, onAcceptEventBody}) => {
  const modalRef = React.useRef();
  const errorModalRef = React.useRef();
  const rateLimitModalRef = React.useRef();
  const loaderRef = React.useRef();

  const [theme, setTheme] = React.useState('');
  const [eventTitle, setEventTitle] = React.useState('');
  const [eventBody, setEventBody] = React.useState('');

  const isValid = theme.length > 0;

  const close = () => {
    setTheme('');
    setEventTitle('');
    setEventBody('');
    modalRef.current && modalRef.current.closeModal();
  };

  const generate = async () => {
    try {
      loaderRef.current.openModal();
      const response = await fetch('/api/event/generate_outline', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ generate: { theme } }),
      });
      if (!response.ok) {
        loaderRef.current.closeModal();
        if (response.status === 429) {
          rateLimitModalRef.current.openModal();
        } else {
          errorModalRef.current.openModal();
        }
        return;
      }

      const json = await response.json();
      setEventTitle(json.result.title || '');
      setEventBody(json.result.body || '');

      loaderRef.current.closeModal();
    } catch (err) {
      loaderRef.current.closeModal();
      errorModalRef.current.openModal();
    }
  };

  const previewContent = (
    <button
      type="button"
      className="a-button a-button--sm a-button--orange"
      style={{borderRadius: 4}}>作成する</button>);
  const modalContent = (
    <div>
      <div
        className="bg-white w-100 border-bottom"
        style={{
          zIndex: 9998,
          borderRadius: '16px 16px 0 0',
          position: 'fixed',
        }}
      >
        <button
          type="button"
          className="close close__modal position--modalclose"
          aria-label="Close"
          onClick={() => close()}
        >
            <span className="text-fz-24px float-right m-2" aria-hidden="true">
              ×
            </span>
        </button>
      </div>
      <div
        className="card bg-gray"
        style={{ paddingTop: '38px', paddingBottom: '144px' }}
      >
        <div className="shadow-sm mb-3 bg-white">
          <div className="container col-md-8 col-lg-6">
            <div className="row justify-content-between p-3_5">
              <label htmlFor="generate-outline-theme">やりたいことを書こう</label>
              <textarea
                name="theme"
                id="generate-outline-theme"
                className="form-control"
                style={{height: 80}}
                maxLength={100}
                value={theme}
                onChange={(e) => setTheme(e.target.value)}
                placeholder="鎌倉に小旅行に行って食べ歩きしたい"
              ></textarea>
              <button type="button" className="a-button a-button__top a-button--orange my-4 w-50" disabled={!isValid} onClick={async () => await generate()}>送信</button>
            </div>
            <div className="row justify-content-between p-3_5">
              <div className="w-100 d-flex justify-content-between align-items-center mb-2">
                <label htmlFor="generated-outline-title">イベント名</label>
              </div>
              <textarea 
                className="form-control" 
                style={{minHeight: 'calc(1.5em + 0.75rem + 2px)', height: 'auto'}} 
                value={eventTitle} 
                onChange={(e) => {
                  setEventTitle(e.target.value)
                }}
              />
            </div>
            <div className="row justify-content-between p-3_5">
              <div className="w-100 d-flex justify-content-between align-items-center mb-2">
                <label htmlFor="generated-outline-body">イベントの説明</label>
              </div>
              <textarea 
                className="form-control" 
                style={{height: 200, overflow: 'auto', whiteSpace: 'pre-wrap'}} 
                value={eventBody} 
                onChange={(e) => {
                  setEventBody(e.target.value)
                }}
              />
            </div>
          </div>
        </div>
        {(eventTitle || eventBody) &&
          <button
            type="button"
            className="a-button a-button--sm a-button--orange"
            style={{borderRadius: 4}}
            onClick={() => {
              onAcceptEventTitle && onAcceptEventTitle(eventTitle)
              onAcceptEventBody && onAcceptEventBody(eventBody);
              alert('イベントに反映しました。');
            }}
          >イベントページに反映</button>
        }
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <ModalContentBaseXl ref={modalRef} previewContent={previewContent} modalContent={modalContent} />
      <ModalAlert
        ref={errorModalRef}
        id="modal-generated-error"
        title="自動生成失敗"
        content="タイトルと説明の自動生成に失敗しました。時間をおいてもう一度お試しください。"
      />
      <ModalAlert
        ref={rateLimitModalRef}
        id="modal-rate-limit-error"
        title="自動生成失敗"
        content="1日の利用数を超過しました。24時間後にもう一度お試しください。"
      />
      <ModalLoader ref={loaderRef} message="約1分お待ちください" dummyProgressShown />
    </React.Fragment>
  );
};
